// AUTO-GENERATED - Do not manually edit this file
// This file is generated by scripts/devlink/config-generator/generate-props-config.js
export default {
    card1ClientTitle: "Senior Director of Product Innovation, Zippo",
    card1Testimonial: "`\"It’s customizable to your needs. It’s like water. It’ll take its shape and wrap around whatever you need it to do.\"`",
    card1Text: "Build custom workflows with a no-code interface, while defining admin controls to maintain cross-org consistency.",
    card1Title: "Flexible yet standardized",
    card2ClientTitle: "Global Client Solutions Director, Black Mountain",
    card2Testimonial: "Almost immediately, we hear ' and how much value it brings.\"'",
    card2Text: "Onboard your entire organization with intuitive products they’ll love to use.",
    card2Title: "Products teams love to use",
    card3ClientTitle: "Director of Treasury, Citizens Bank <br />",
    card3Testimonial: " It's like an iPhone in a way in that you just know how and what you want to do next.\\",
    card3Text: "See value fast with products that are quick to implement and even easier to learn.",
    card3Title: "Fast time to value",
    customer1Headshot: {
        src: "https://dapulse-res.cloudinary.com/image/upload/v1750332192/growth-marketing/web-experience/hp-jun-25/monday-difference/diff-customer-headshot-3.png",
        alt: ""
    },
    customer1Logo: {
        src: "https://dapulse-res.cloudinary.com/image/upload/v1750332191/growth-marketing/web-experience/hp-jun-25/monday-difference/diff-logo-1.png",
        alt: ""
    },
    customer2Headshot: {
        src: "https://dapulse-res.cloudinary.com/image/upload/v1750332192/growth-marketing/web-experience/hp-jun-25/monday-difference/diff-customer-headshot-2.png",
        alt: ""
    },
    customer2Logo: {
        src: "https://dapulse-res.cloudinary.com/image/upload/v1750332191/growth-marketing/web-experience/hp-jun-25/monday-difference/diff-logo-2.png",
        alt: ""
    },
    customer3Headshot: {
        src: "https://dapulse-res.cloudinary.com/image/upload/v1750332192/growth-marketing/web-experience/hp-jun-25/monday-difference/diff-customer-headshot-1.png",
        alt: ""
    },
    customer3Logo: {
        src: "https://dapulse-res.cloudinary.com/image/upload/v1750332191/growth-marketing/web-experience/hp-jun-25/monday-difference/diff-logo-3.png",
        alt: ""
    },
    stat1Subtitle: "hours saved per month",
    stat1Text: "6,970",
    stat2Subtitle: "conversion rate increase",
    stat2Text: "+15%",
    stat3Subtitle: "manual actions saved per month",
    stat3Text: "28,000",
    title: "The monday.com difference"
};
